import { render, staticRenderFns } from "./form-plan.vue?vue&type=template&id=7a98b885&scoped=true"
import script from "./form-plan.vue?vue&type=script&setup=true&lang=js"
export * from "./form-plan.vue?vue&type=script&setup=true&lang=js"
import style0 from "./form-plan.vue?vue&type=style&index=0&id=7a98b885&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a98b885",
  null
  
)

export default component.exports